import { API_STATES } from "@/helpers"

const getters = {
  isAuthenticated : state => !!state.accessToken,
  appLoaded       : state =>(state.appLoadingState === API_STATES.REQUEST_SUCCESS),
  isSuperAdmin    : state => state.userPermissions.roles && state.userPermissions.roles.superadmin,
  isEpicorAdmin   : state => state.userPermissions.roles && state.userPermissions.roles.epicoradmin

}

export default getters
